export enum EmploymentSituationName {
  EMPLOYED = 'EMPLOYED',
  UNEMPLOYED = 'UNEMPLOYED',
  INDEPENDENT = 'INDEPENDENT',
  RENTIER = 'RENTIER',
  LEGAL_PERSON = 'LEGAL_PERSON',
  PENSIONER = 'PENSIONER',
};
